<template>
    <v-container>      
      <v-card transition="scroll-x-reverse-transition">
        <v-card-title class="headline">
        <v-btn icon @click="$router.push('usuarios')">
            <v-icon>
                arrow_back
            </v-icon>
        </v-btn>
          {{usuario.nomeCompleto}}
          <v-card-subtitle :class="usuario.status == 'ativo'? 'green--text' : 'red--text'">{{ usuario.status }}</v-card-subtitle>
          
          <v-spacer/>
          <v-btn v-if="usuario.status == 'inativo'" :loading="load" color="green darken-3" class="mr-2 white--text">Reativar Usuário <v-icon>check</v-icon></v-btn> 
          <v-btn v-if="usuario.status == 'ativo'" :loading="load"  color="secondary accent-4" class="mr-2">Desativar Usuário <v-icon>block</v-icon></v-btn> 
          <v-btn color="secondary accent-4" :loading="load" class="mr-2">Resetar senha <v-icon>lock</v-icon></v-btn>
          <v-btn color="accent" :loading="load" @click="$router.push({name: 'cadastrarUsuario', params: {cadastro: false, _id: _id}})">Editar perfil <v-icon>edit</v-icon></v-btn>  
        </v-card-title>
        <v-alert
            class="mx-4"
            v-model="cadastroIncompleto"
            dense
            border="left"
            type="warning"
          >
            Algumas informações do perfil estão incompletas. Favor completar o cadastro.
          </v-alert>
              <v-card-text>
          <strong>Informações Pessoais</strong>
          <v-row dense>            
            <v-col  xs="6" md="3"  lg="2">
              <v-card-text>
                <v-list-item-title>Nome Social:</v-list-item-title>
                <v-list-item-subtitle>{{ usuario.nomeSocial }}</v-list-item-subtitle>
              </v-card-text>
              
            </v-col>
            <v-col  xs="6" md="3" lg="2">
                    <v-card-text>
                    <v-list-item-title>Nome Completo:</v-list-item-title>
                    <v-list-item-subtitle>{{ usuario.nomeCompleto }}</v-list-item-subtitle>
                    </v-card-text>  
            </v-col>
            <v-col  xs="6" md="3" lg="2">
              <v-card-text>
                <v-list-item-title>Nome de Tratamento:</v-list-item-title>
                <v-list-item-subtitle>{{ usuario.nomeTratamento }}</v-list-item-subtitle>
              </v-card-text>
            </v-col>
            <v-col  xs="6" md="3" lg="2">              
              <v-card-text>      
                <v-list-item-title>Data de Nascimento:</v-list-item-title>
                <v-list-item-subtitle>{{ formatarData(usuario.dataNascimento) }}</v-list-item-subtitle>
              </v-card-text>   
                
            </v-col>
            <v-col  xs="6" md="3" lg="2">
              
              <v-card-text>      
              <v-list-item-title>Gênero:</v-list-item-title>
                    <v-list-item-subtitle>{{ usuario.genero }}</v-list-item-subtitle>
               </v-card-text>   
            </v-col>
            <v-col  xs="6" md="3" lg="2">
                
              <v-card-text>      
              <v-list-item-title>CPF:</v-list-item-title>
                    <v-list-item-subtitle>{{ formatarCPF(usuario.cpf) }}</v-list-item-subtitle>
               </v-card-text>   
            </v-col>
            <v-col  xs="6" md="3" lg="2">
                
              <v-card-text>      
              <v-list-item-title>Perfil:</v-list-item-title>
                    <v-list-item-subtitle>{{ usuario.perfil }}</v-list-item-subtitle>
               </v-card-text>   
            </v-col>
            <v-col  xs="6" md="3" lg="2">
                
              <v-card-text>      
              <v-list-item-title>Idioma Preferido:</v-list-item-title>
                    <v-list-item-subtitle>{{ usuario.idiomaPreferido }}</v-list-item-subtitle>
               </v-card-text>   
              
            </v-col>
            
            <v-col  xs="6" md="3" lg="2">
                
              <v-card-text>      
              <v-list-item-title>ID Usuário:</v-list-item-title>
                    <v-list-item-subtitle>{{ usuario.idiomaPreferido }}</v-list-item-subtitle>
                        </v-card-text>       
            </v-col>
            <v-col  xs="6" md="3" lg="2">
                
              <v-card-text>      
              <v-list-item-title>ID Prestador:</v-list-item-title>
                    <v-list-item-subtitle>{{ usuario.idiomaPreferido }}</v-list-item-subtitle>
                        </v-card-text>       
            </v-col>
          </v-row>
          <v-divider/>
          <strong>Endereço</strong>
          <v-row dense> 
            <v-col  xs="6" md="3" lg="2">                
              <v-card-text>  
                <v-list-item-title>Logradouro:</v-list-item-title>
                <v-list-item-subtitle>{{ endereco.logradouro }}</v-list-item-subtitle>
              </v-card-text>   
            </v-col>
            <v-col  xs="6" md="3" lg="2">
                
              <v-card-text>  
              <v-list-item-title>Número:</v-list-item-title>
                <v-list-item-subtitle>{{ endereco.numero }}</v-list-item-subtitle>
                        </v-card-text>   
            </v-col>
            <v-col  xs="6" md="3" lg="2">
                    
              <v-card-text>      
              <v-list-item-title>Complemento</v-list-item-title>
                    <v-list-item-subtitle>{{ endereco.complemento}}</v-list-item-subtitle>
                        </v-card-text>      
            </v-col>
            <v-col  xs="6" md="3" lg="2">
                    
              <v-card-text>      
              <v-list-item-title>Bairro</v-list-item-title>
                    <v-list-item-subtitle>{{ endereco.bairro }}</v-list-item-subtitle>
                        </v-card-text>      
            </v-col>
            <v-col  xs="6" md="3" lg="2">
                    
              <v-card-text>      
              <v-list-item-title>Cidade:</v-list-item-title>
                    <v-list-item-subtitle>{{ endereco.cidade }}</v-list-item-subtitle>
                        </v-card-text>      
            </v-col>
            <v-col  xs="6" md="3" lg="2">
                    
              <v-card-text>      
              <v-list-item-title>Estado:</v-list-item-title>
                    <v-list-item-subtitle>{{ endereco.cidade }}</v-list-item-subtitle>
                        </v-card-text>      
            </v-col>
            <v-col  xs="6" md="3" lg="2">
                    
              <v-card-text>      
                <v-list-item-title>Cep:</v-list-item-title>
                <v-list-item-subtitle>{{ endereco.cidade }}</v-list-item-subtitle>
              </v-card-text>      
            </v-col>
          </v-row>
          <v-divider/>
          
          <strong>Contato</strong>
          <v-row dense>
            <v-col  xs="6" md="3" lg="2">
              <v-card-text>
              <v-list-item-title>Telefone:</v-list-item-title>
              <v-list-item-subtitle>{{ contato.telefone }}</v-list-item-subtitle>
              </v-card-text>          
            </v-col>
            
            <v-col  xs="6" md="3" lg="2">
              <v-card-text>
              <v-list-item-title>Celular:</v-list-item-title>
              <v-list-item-subtitle>{{ contato.celular }}</v-list-item-subtitle>
              </v-card-text>          
            </v-col>

            <v-col  xs="6" md="3" lg="2">
              <v-card-text>
              <v-list-item-title>Email:</v-list-item-title>
              <v-list-item-subtitle>{{ contato.email }}</v-list-item-subtitle>
              </v-card-text>          
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
            
        </v-card-actions>
      </v-card>
    </v-container>
  </template>
<script>
import usuarioService from '../../../services/usuario.service'

export default {
  props: {
    _id: {
      type: String
    }
  },
  data () {
    return {
      load: false,
      cadastroIncompleto: false,
      usuario: {
        nomeSocial: '',
        nomeCompleto: '',
        nomeTratamento: '',
        dataNascimento: '',
        genero: '',
        cpf: '',
        username: '',
        senha: '',
        perfil: '',
        idiomaPreferido: ''
      },
      contato: {
        telefone: '',
        celular: '',
        email: ''
      },
      endereco: {
        logradouro: '',
        numero: '',
        complemento: '',
        bairro: '',
        cidade: '',
        estado: '',
        cep: ''
      }
    }
  },
  methods: {
    buscarUsuario () {
      this.load = true
      usuarioService.buscarUsuario(this._id).then(r => {
        if (r.status == 200) {
          console.log('resp: ', r.data)
          this.usuario = r.data
          this.endereco = r.data.endereco
          this.contato = r.data.contato

        }
      }).finally(() => {
        (this.algumAtributoVazio(this.usuario) ? this.cadastroIncompleto = true : this.cadastroIncompleto = false)
        this.load = false
      })
    },
    formatarData (data) {
      // Implemente aqui a formatação da data se necessário
      return data
    },
    formatarCPF (cpf) {
      // Implemente aqui a formatação do CPF se necessário
      return cpf
    },
    algumAtributoVazio (obj) {
      for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
          // Verifica se o valor é uma string e se está vazio
          if (typeof obj[key] === 'string' && obj[key].trim() === '') {
            return true // Retorna true se pelo menos um atributo estiver vazio
          }
          // Verifica recursivamente se há atributos vazios em objetos aninhados
          if (typeof obj[key] === 'object' && this.algumAtributoVazio(obj[key])) {
            return true
          }
        }
      }
      return false // Retorna false se nenhum atributo estiver vazio
    }

  },
  mounted () {
    this.buscarUsuario()
  }
}
</script>